if (!Array.prototype.uniq) {
  Array.prototype.uniq = function() {
    'use strict'
    if (this === null) {
      throw new TypeError('Array.prototype.find called on null or undefined')
    }

    let seen = [],
      result = []

    this.forEach(val => {
      if (!seen.includes(val)) {
        seen.push(val)
        result.push(val)
      }
    })

    return result
  }
}

